import React, { useEffect, useState } from 'react';
import { Box, Heading, Text, Divider, useColorModeValue } from '@chakra-ui/react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { db, storage } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { getDownloadURL, ref } from 'firebase/storage';
import { Navigation, Pagination } from 'swiper/modules';
import LottieLoader from '../Animations/LottieLoader';

const Blog = () => {
  // State to store blog posts
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const textColor = useColorModeValue('gray.800', 'whiteAlpha.900');
  const dividerColor = useColorModeValue('gray.300', 'gray.600');
  const bg = useColorModeValue("white", "gray.800");

  useEffect(() => {
    const fetchBlogPosts = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'blogPosts'));

        const postsData = await Promise.all(
          querySnapshot.docs.map(async (doc) => {
            const data = doc.data();

            // Fetch image URLs from storage
            const imageUrls = await Promise.all(
              data.images.map(async (imagePath) => {
                const imageRef = ref(storage, imagePath);
                const imageUrl = await getDownloadURL(imageRef);
                return imageUrl;
              })
            );

            return {
              ...data,
              images: imageUrls,
            };
          })
        );

        setBlogPosts(postsData);
        setLoading(false);

      } catch (error) {
        console.error('Error fetching blog posts:', error);
      }
    };

    fetchBlogPosts();
  }, []);

  if (loading) {
    return (
      <Box
        position={{base: "fixed", md: "absolute"}}
        top="0"
        left="0"
        right="0"
        bottom="0"
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg={bg} // Optional: Add a background to match the Portfolio section's bg
      >
        <LottieLoader />
      </Box>
    );
  }
  return (
    <Box p={{ base: 4, md: 8 }} bg={bg} minH="100vh">
      {blogPosts.map((post, index) => (
        <Box key={index} mb={8}>
          <Heading
            as="h2"
            size={{ base: "md", md: "xl" }}
            color={textColor}
            mb={2}
            textAlign={{ base: "center", md: "left" }}
          >
            {post.title}
          </Heading>
          <Text fontSize={{ base: "sm", md: "md" }} color={textColor} mb={4} textAlign={{ base: "center", md: "left" }}>
            {post.description}
          </Text>
          <Divider my={4} color={dividerColor} />

          {/* Swiper Carousel */}
          <Swiper
            spaceBetween={10}
            slidesPerView={1}
            modules={[Navigation, Pagination]}
            navigation
            pagination={{ clickable: true }}
            breakpoints={{
              640: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
          >
            {post.images.map((imageUrl, idx) => (
              <SwiperSlide key={idx}>
                <img
                  src={imageUrl}
                  alt={`Slide ${idx + 1}`}
                  style={{ width: "100%", borderRadius: "8px" }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      ))}
    </Box>
  );
};

export default Blog;
